App.factory('bulkExportFactory', bulkExportFactory);

bulkExportFactory.$inject = [
    'DispatcherService'
];

function bulkExportFactory(DispatcherService) {
    return {
        send: function(selection) {
            return DispatcherService.post('bulk-exports', { selection: selection });
        }
    };
}